module.exports = __webpack_public_path__ + "media/placeholders/media-plan-opacity-ce2478fc.png";